import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=101d6bc1&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=101d6bc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101d6bc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('101d6bc1')) {
      api.createRecord('101d6bc1', component.options)
    } else {
      api.reload('101d6bc1', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=101d6bc1&scoped=true&", function () {
      api.rerender('101d6bc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/Documents.vue"
export default component.exports